import { useData } from "data/data-provider";
import DesignARouter from "routers/DesignARouter";
import DesignBRouter from "routers/DesignBRouter";

function App() {
  const { loadingCompanyDetails, ourCompany } = useData();

  return (
    <div className="bg-bg-color">
      {loadingCompanyDetails ? (
        <div className="flex justify-center items-center col-span-full min-h-[100vh]">
          <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-secondary-100"></div>
        </div>
      ) : (
        // <div className="text-base text-text-color bg-bg-color">
        //   {ourCompany?.default_template === "design2" ? (
        //     <DesignBRouter />
        //   ) : (
        <DesignARouter />
        //   )}
        // </div>
      )}
    </div>
  );
}

export default App;
